import { useState } from "react"
import Button from "@/v2-backoffice-client/components/button"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserUpdateDialog from "@/v2-backoffice-client/user/update/UserUpdateDialog"
import UserRecreateIdentityDialog from "@/v2-backoffice-client/user/recreateIdentity/UserRecreateIdentityDialog"
import UserIdentityBadge from "@/v2-backoffice-client/user/identity/UserIdentityBadge"
import { getIdentityFix } from "@/v2-backoffice-client/user/identity/userIdentity.constants"

export type UserIdentityCellProps = {
  user: UserFragment
  showHealthy?: boolean
}

// Renders the identity badge plus its repair affordance. The fix button is
// handed to the badge tooltip, but the dialog it opens is rendered HERE as a
// SIBLING of the badge — never inside the tooltip. Tooltip content is
// unmounted when the tooltip closes, so a dialog mounted inside it would
// dismount the moment the pointer leaves the badge; keeping the dialog out
// here lets it outlive the tooltip.
function UserIdentityCell(props: UserIdentityCellProps) {
  const { user, showHealthy } = props
  const fix = getIdentityFix(user.IdentitySyncStatus)
  const [open, setOpen] = useState(false)

  const action = fix ? (
    <Button variant="outline" size="xs" onClick={() => setOpen(true)}>
      {fix === "change-email" ? "Update Email" : "Recreate Login"}
    </Button>
  ) : undefined

  return (
    <>
      <UserIdentityBadge
        user={user}
        showHealthy={showHealthy}
        action={action}
      />
      {fix === "change-email" && (
        <UserUpdateDialog user={user} open={open} onOpenChange={setOpen} />
      )}
      {fix === "recreate-login" && (
        <UserRecreateIdentityDialog
          userId={user.Id}
          defaultEmail={user.Email ?? undefined}
          open={open}
          onOpenChange={setOpen}
        />
      )}
    </>
  )
}

export default UserIdentityCell
